import { useEffect, useRef, useState } from "react";
export function useClipboard(email: string) {
  const [copyState, setCopyState] = useState("");
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect(() => {
    if (!copyState) return;
    const timer = setTimeout(() => setCopyState(""), 2500);
    return () => clearTimeout(timer);
  }, [copyState]);
  async function copyEmail() {
    const fallback = () => {
      const previousFocus = document.activeElement as HTMLElement | null;
      const input = document.createElement("textarea");
      input.value = email;
      input.readOnly = true;
      input.style.cssText =
        "position:fixed;top:0;left:0;opacity:0;width:1px;height:1px";
      document.body.appendChild(input);
      input.select();
      let copied = false;
      try {
        copied = document.execCommand("copy");
      } catch {
        /* Direct email remains available. */
      }
      input.remove();
      previousFocus?.focus({ preventScroll: true });
      return copied;
    };
    let timer: ReturnType<typeof setTimeout> | undefined;
    try {
      if (!navigator.clipboard || !window.isSecureContext) {
        setCopyState(
          fallback() ? "Email copied ✓" : "Please use the email link above.",
        );
        return;
      }
      await Promise.race([
        navigator.clipboard.writeText(email),
        new Promise<never>((_, reject) => {
          timer = setTimeout(
            () => reject(new Error("Clipboard timeout")),
            1500,
          );
        }),
      ]);
      if (mounted.current) setCopyState("Email copied ✓");
    } catch {
      if (mounted.current)
        setCopyState(
          fallback() ? "Email copied ✓" : "Please use the email link above.",
        );
    } finally {
      if (timer) clearTimeout(timer);
    }
  }
  return { copyState, copyEmail };
}
